module.exports = __webpack_public_path__ + "static/media/info_white.3855482f.svg";